import React, { useEffect, useState } from 'react';
import sortby from 'lodash.sortby';
import { PropTypes } from 'prop-types';

import PropertyCardsPaged from '../../_molecules/PropertyCardsPaged';
import LoadingArea from '@molecules/LoadingArea';
import { BodyLarge } from '@styled';
import { getIsActive } from '@general/helpers/propertyStatus.helpers';
import useMemberFull from '@hooks/useMemberFull';
import useIcscTracking from '@tracking/useIcscTracking';

const MemberProfileListedProperties = ({ graphID }) => {
    const [properties, setProperties] = useState();
    const { data } = useMemberFull(graphID);
    const { trackEvent } = useIcscTracking();

    const handleListedPropertyClick = hit => {
        trackEvent({
            exclude: ['Algolia'],
            click: {
                target: 'click_member_profile_listed_property',
                value: 'Click Member Profile Listed Property',
            },
        });
    };

    useEffect(() => {
        if (data?.properties) {
            setProperties(
                sortby(
                    data.properties.filter(property => getIsActive(property.activatedAt)),
                    'activatedAt'
                ).reverse()
            );
        }
    }, [data]);

    if (!properties) {
        return <LoadingArea />;
    }

    if (data.properties.length === 0) {
        return <BodyLarge>{data.firstName} has no listed properties.</BodyLarge>;
    }

    return (
        <div className="fade-in-fast">
            <BodyLarge className="mb-2rem">{data.firstName}'s listed properties</BodyLarge>
            <PropertyCardsPaged
                properties={properties}
                showShareIcon={false}
                onPropertyClick={hit => handleListedPropertyClick(hit)}
            />
        </div>
    );
};

MemberProfileListedProperties.propTypes = {
    graphID: PropTypes.string,
};

export default MemberProfileListedProperties;
